/**
 * lib/views/javascripts/login/password-eye.js — the show/hide toggle on the
 * sign-in page's password field.
 *
 * Contents: view
 * Ontology: Code object M33C-1029 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Binding ──────────────────────────────────────────────────────────────
export function bindPasswordEye(doc = document) {
  const pw = doc.getElementById('m33-login-pw');
  const eye = doc.getElementById('m33-login-pw-eye');
  if (!eye || !pw) return;
  eye.addEventListener('click', () => {
    const show = pw.type === 'password';
    pw.type = show ? 'text' : 'password';
    eye.classList.toggle('m33-eye-open', show);
    eye.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
  });
}
